"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* global twttr */
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var attach_script_1 = tslib_1.__importDefault(require("../../../../../common/utils/attach-script"));
var accessible_social_button_1 = tslib_1.__importDefault(require("./accessible-social-button"));
var LIBRARY_URL = 'https://platform.twitter.com/widgets.js';
var buttonOptions = {
    showScreenName: false,
    showCount: false,
    size: 'small',
};
var TwitterButton = /** @class */ (function (_super) {
    tslib_1.__extends(TwitterButton, _super);
    function TwitterButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function (containerNode) {
            return twttr.widgets.createFollowButton(_this.props.cardData.id, containerNode, buttonOptions);
        };
        return _this;
    }
    TwitterButton.prototype.attachScript = function () {
        if (window.twttr) {
            return Promise.resolve();
        }
        return (0, attach_script_1.default)(LIBRARY_URL);
    };
    TwitterButton.prototype.render = function () {
        var _a = this.props, isAccessible = _a.isAccessible, twitterButtonTitle = _a.twitterButtonTitle;
        return (react_1.default.createElement(accessible_social_button_1.default, { isAccessible: isAccessible, title: twitterButtonTitle, attachScript: this.attachScript, initButton: this.init }));
    };
    TwitterButton.propTypes = {
        cardData: prop_types_1.default.object,
        isAccessible: prop_types_1.default.bool,
        twitterButtonTitle: prop_types_1.default.string,
    };
    return TwitterButton;
}(react_1.default.Component));
exports.default = TwitterButton;
//# sourceMappingURL=twitter.js.map